export default "__VITE_ASSET__bgn2PqmW__"